import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobRole: null,
  jobRoleId: null,
  lastAccessed: [],
  name: null,
  firstName: null,
};

const userConfigurationSlice = createSlice({
  name: "userConfiguration",
  initialState,
  reducers: {
    resetState(state, action) {
      state = initialState;
    },
    setState(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setLastAccessed(state, action) {
      let domainLastAccessed = state.lastAccessed.find(
        (x) => x.domainId === action.payload.domainId
      );

      if (domainLastAccessed) {
        domainLastAccessed.skillPathId = action.payload.skillPathId;
        domainLastAccessed.skillPathLevelId = action.payload.skillPathLevelId;
      } else {
        state.lastAccessed = [
          ...state.lastAccessed,
          {
            ...action.payload,
          },
        ];
      }
    },
    removeLastAccessed(state, action) {
      state.lastAccessed = state.lastAccessed.filter(
        (x) => x.domainId !== action.payload.domainId
      );
    },
  },
});

export const userConfigurationActions = userConfigurationSlice.actions;

export default userConfigurationSlice.reducer;
